import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import content from '../data/content';

export default function Profile() {
  const { id } = useParams();
  const member = content.team.find((m) => m.id === Number(id));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!member) {
    return (
      <div className="profile">
        <div className="container">
          <p>Mitarbeiter nicht gefunden.</p>
          <Link to="/" className="btn btn-outline">← Zurück</Link>
        </div>
      </div>
    );
  }

  const getInitials = (name) => name.split(' ').map((n) => n[0]).join('');

  return (
    <div className="profile">
      <div className="container">
        <Link to="/#team" className="btn btn-outline" style={{ marginBottom: 32 }}>
          ← Zurück zum Team
        </Link>

        <div className="profile-header">
          {member.image ? (
            <img src={member.image} alt={member.name} className="profile-avatar" />
          ) : (
            <div className="profile-avatar-placeholder">{getInitials(member.name)}</div>
          )}
          <div className="profile-info">
            <h1>{member.name}</h1>
            <div className="role">{member.role}</div>
            <div className="profile-contacts">
              <div className="profile-contact-item">
                📞 <a href={`tel:${member.phone}`}>{member.phone}</a>
              </div>
              <div className="profile-contact-item">
                ✉️ <a href={`mailto:${member.email}`}>{member.email}</a>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 12, marginTop: 8 }}>
              <div className="team-card-availability">
                <span className="dot" /> {member.availability}
              </div>
              {member.cvDownloads && member.cvDownloads.length > 0 ? (
                member.cvDownloads.map((cv) => (
                  <a
                    key={cv.slug}
                    href={`https://sijelly.com/api/dok/${cv.slug}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                  >
                    {cv.label}
                  </a>
                ))
              ) : member.cvSlug ? (
                <a
                  href={`https://dev.sijelly.com/api/dok/${member.cvSlug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  📄 Lebenslauf herunterladen
                </a>
              ) : null}
            </div>
          </div>
        </div>

        <div className="profile-sections">
          {member.experience.summary && (
            <div className="profile-section">
              <h2>Erfahrungen</h2>
              <p>{member.experience.summary}</p>
              {member.experience.skills.length > 0 && (
                <ul style={{ marginTop: 16 }}>
                  {member.experience.skills.map((skill, i) => (
                    <li key={i}>{skill}</li>
                  ))}
                </ul>
              )}
            </div>
          )}

          {member.certifications && member.certifications.length > 0 && (
            <div className="profile-section">
              <h2>Zertifikate</h2>
              <div className="profile-tags">
                {member.certifications.map((cert, i) => (
                  <span key={i}>{cert}</span>
                ))}
              </div>
            </div>
          )}

          {member.projects.length > 0 && (
            <div className="profile-section">
              <h2>Persönliche Referenzen / Projekte (Auszug)</h2>
              <ul>
                {member.projects.map((project, i) => (
                  <li key={i}>{project}</li>
                ))}
              </ul>
            </div>
          )}

          {member.education && member.education.length > 0 && (
            <div className="profile-section">
              <h2>Ausbildung & Werdegang</h2>
              <ul>
                {member.education.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          )}

          {member.workExperience && member.workExperience.length > 0 && (
            <div className="profile-section">
              <h2>Berufserfahrung</h2>
              {member.workExperience.map((job, i) => (
                <div key={i} style={{ marginBottom: 16 }}>
                  <h3 style={{ fontSize: '1rem', marginBottom: 8 }}>{job.title}</h3>
                  <ul>
                    {job.tasks.map((task, j) => (
                      <li key={j}>{task}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          )}

          {member.languages && member.languages.length > 0 && (
            <div className="profile-section">
              <h2>Sprachen</h2>
              <div className="profile-tags">
                {member.languages.map((lang, i) => (
                  <span key={i}>{lang}</span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
